<template>
  <div class="h-full elegant-sidebar overflow-y-auto">
    <div class="p-8 space-y-8">
      <div class="text-center">
        <el-button 
          type="warning" 
          @click="$emit('openPrice')" 
          class="btn-warning-elegant px-8 py-3 text-sm font-semibold"
          size="large"
        >
          <span>💎 {{ $t('Price') }}</span>
        </el-button>
      </div>

      <div class="space-y-6">
        <div class="space-y-2">
          <h2 class="title-elegant">{{ $t('Data') }}</h2>
          <p class="text-sm text-slate-500">添加数据点来创建桑基图</p>
        </div>
        <div class="space-y-4">
          <div class="space-y-2">
            <label class="subtitle-elegant">源节点</label>
            <el-input 
              v-model="localSource" 
              :placeholder="$t('source')" 
              class="input-elegant" 
              clearable
              size="large"
            />
          </div>
          
          <div class="space-y-2">
            <label class="subtitle-elegant">目标节点</label>
            <el-input 
              v-model="localTarget" 
              :placeholder="$t('target')" 
              class="input-elegant" 
              clearable
              size="large"
            />
          </div>
          
          <div class="space-y-2">
            <label class="subtitle-elegant">数值</label>
            <el-input-number 
              v-model="localValue" 
              :placeholder="$t('value')" 
              class="input-elegant w-full" 
              clearable
              size="large"
              :min="0"
            />
          </div>
        </div>
        <el-button 
          type="primary" 
          class="w-full btn-primary-elegant py-3 text-sm font-semibold" 
          @click="handleAddData"
          size="large"
        >
          <span>✨ {{ $t('Add Data') }}</span>
        </el-button>
      </div>

      <!-- 数据表格 -->
      <div class="space-y-3">
        <el-scrollbar max-height="40vh" class="custom-scrollbar">
          <el-table :data="chartData" class="w-full" size="small">
            <el-table-column prop="source" :label="$t('Source')" />
            <el-table-column prop="target" :label="$t('Target')" />
            <el-table-column prop="value" :label="$t('Value')" />
            <el-table-column :label="$t('Operations')" width="80" align="center">
              <template #default="scope">
                <el-button 
                  circle 
                  type="danger" 
                  @click="$emit('deleteData', scope.$index)"
                  size="small"
                >
                  <el-icon><Delete /></el-icon>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <!-- 语言选择和底部按钮 -->
      <div class="space-y-4 pt-4 border-t border-gray-200">
        <el-select 
          v-model="selectedLang" 
          @change="$emit('changeLang', $event)" 
          placeholder="Select Language" 
          class="w-full"
          size="default"
        >
          <el-option 
            v-for="(item, index) in languageOptions" 
            :key="index" 
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        
        <div class="flex justify-center">
          <el-button 
            plain 
            @click="$emit('openService')" 
            class="rounded-full px-6 py-2 text-sm"
            size="default"
          >
            {{ $t('Service') }}
          </el-button>
        </div>
        
        <p class="text-xs text-gray-500 text-center">
          Copyright © emperinter
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Delete } from '@element-plus/icons-vue'

const props = defineProps({
  chartData: {
    type: Array,
    default: () => []
  },
  source: {
    type: String,
    default: ''
  },
  target: {
    type: String,
    default: ''
  },
  value: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(['openPrice', 'addData', 'deleteData', 'changeLang', 'openService'])

const localSource = ref(props.source)
const localTarget = ref(props.target)
const localValue = ref(props.value)
const selectedLang = ref(null)

// 语言选项
const languageOptions = [
  { label: 'English', value: 'en-US' },
  { label: '中文', value: 'cn' },
  { label: '日本語', value: 'ja' },
  { label: 'Français', value: 'fr' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Italiano', value: 'it' },
  { label: 'Español', value: 'es' },
  { label: '한국어', value: 'ko' }
]

const handleAddData = () => {
  if (localSource.value && localTarget.value && localValue.value > 0) {
    emit('addData', {
      source: localSource.value,
      target: localTarget.value,
      value: localValue.value
    })
    localSource.value = ''
    localTarget.value = ''
    localValue.value = 0
  }
}
</script>

<style scoped>
.custom-scrollbar {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(136, 136, 136, 0.5) transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 0;
}

.custom-scrollbar:hover::-webkit-scrollbar {
  width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(136, 136, 136, 0.5);
  border-radius: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(136, 136, 136, 0.8);
}
</style>